import { render } from "./CartWidget.vue?vue&type=template&id=54ffbea8&scoped=true"
import script from "./CartWidget.vue?vue&type=script&lang=js"
export * from "./CartWidget.vue?vue&type=script&lang=js"

import "./CartWidget.vue?vue&type=style&index=0&id=54ffbea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ffbea8"]])

export default __exports__